import React from "react";
//Limitless imports
import { log as pilog } from "common/utils";
import * as WSClient from "common/utils/paho-mqtt";
import { getWebSocketURL } from "common/apis";
const win = typeof window === "undefined" ? {} : window;
win.Paho = {
  MQTT: WSClient
};
//the above is why JavaScript is the worst. A polyfill to help the terrible paho-mqtt not self-destruct.

let client = null;
let isConnected = false;
const MAX_RECONNECTS = Number.parseInt(process.env.REACT_APP_WS_MAX_RECONNECTS || 3);
let reconnects = 0;
const WS_CON_STATE_MAX = "max-reconnects-reached";
export const WS_CON_STATE_DISCONNECTED = "disconnected";
export const WS_CON_STATE_CONNECTED = "connected";
export const WS_CON_STATE_RECONNECTING = "reconnecting";
export const useWebSocketsHook = eventProcessorHook => {
  const log = pilog.getLogger("useWebSocketsHooks");
  const [events, setEvents] = React.useState([]);
  const [wsStatus, setWSStatus] = React.useState(WS_CON_STATE_DISCONNECTED);
  const [previousWSState, setPreviousWSState] = React.useState();
  const [disableWindowFocus, setDisableWindowFocus] = React.useState(false);
  const {
    onConnect,
    onDisconnect,
    onReconnect,
    processWebSocketEvent,
    onHookInitialisation,
    ...rest
  } = eventProcessorHook();
  React.useEffect(() => {
    if (typeof onHookInitialisation === "function") {
      onHookInitialisation({
        conditionalWSReconnect
      });
    }
    if (process.env.REACT_APP_TYPE !== "mobile") {
      window.addEventListener("focus", handleWindowFocus);
      return () => {
        window.removeEventListener("focus", handleWindowFocus);
      };
    }
    return null;
  }, [disableWindowFocus]);
  React.useEffect(() => {
    if (events.length !== 0) {
      events.map(event => {
        processWebSocketEvent(event);
      });
    }
  }, [events]);
  React.useEffect(() => {
    //if we've reached out max reconnects allowed, disconnect
    if (wsStatus === WS_CON_STATE_MAX) {
      disconnectFromWebSocket();
    }
    log.info({
      wsStatus
    });
    //if we are no connected, but weren't call the onReconnect
    if (wsStatus === WS_CON_STATE_CONNECTED && previousWSState !== WS_CON_STATE_CONNECTED && typeof onReconnect === "function") {
      onReconnect(client);
    }
    setPreviousWSState(wsStatus);
  }, [wsStatus]);
  const handleWindowFocus = () => {
    if (disableWindowFocus) {
      return;
    }
    //if reconnects !== 0, then it's already try to reconnect
    if (reconnects !== 0 || isConnected === false) {
      forceReconnect();
    } else {
      //if we're already connected and the window comes into focus, treat like it's a reconnect
      //as some browsers (i.e. firefox) block websocket traffic but don't disconnect when out of focus
      if (typeof onReconnect === "function") {
        onReconnect(client);
      }
    }
  };
  const conditionalWSReconnect = () => {
    if (wsStatus === WS_CON_STATE_DISCONNECTED) {
      forceReconnect();
    }
  };
  const forceReconnect = () => {
    setDisableWindowFocus(false);
    reconnects = 0;
    connectToWebSocket();
  };
  const forceDisconnect = () => {
    setDisableWindowFocus(true);
    reconnects = MAX_RECONNECTS;
    disconnectFromWebSocket();
  };
  const connectToWebSocket = () => {
    if (process.env.REACT_APP_WS_HISTORY) {
      window.wsEvents = [];
      window.wsEventsRejected = [];
    }
    if (!isConnected) {
      getWebSocketURL(url => {
        log.info("Initialising WebSocket Connection");
        client = new WSClient.Client(url, Math.floor((100000000 + Math.random()) * 900000000).toString());
        client.onConnected = isReconnect => {
          log.info("Successfully connected to Web Sockets");
          onConnect(client, isReconnect);
          isConnected = true;
          setWSStatus(WS_CON_STATE_CONNECTED);
        };
        client.onConnectionLost = reason => {
          log.info("WebSocket Connection Lost!.. ", reason);
          isConnected = false;
          setWSStatus(WS_CON_STATE_DISCONNECTED);
        };
        client.onMessageArrived = message => {
          try {
            const event = JSON.parse(message.payloadString);
            event.topic = message.destinationName;
            console.log("Event Arrived!", event);
            log.debug("Event Arrived!", event);
            setEvents([...events, event]);
          } catch (error) {
            log.error("Failed to process web socket event %o", error);
          }
        };
        client.connect({
          reconnect: true,
          reconnectInterval: 10,
          getReconnectURL: args => {
            reconnects++;
            log.info("Reconnecting", reconnects);
            if (reconnects < MAX_RECONNECTS && isConnected === false) {
              log.info("Allowed to reconnect");
              getWebSocketURL(args);
              setWSStatus(WS_CON_STATE_RECONNECTING);
            } else {
              setWSStatus(WS_CON_STATE_MAX);
            }
          },
          //heartbeat is default to 60 seconds
          keepAliveInterval: process.env.REACT_APP_WS_HEARTBEAT ? Number(process.env.REACT_APP_WS_HEARTBEAT) : 60,
          onSuccess: () => {
            log.debug("Successfully connected to Realtime Endpoint!");
          },
          onFailure: error => {
            log.debug("Failed to setup web sockets %o", error);
          }
        });
      }, error => {
        isConnected = false;
        log.info("Failed to get secure web socket URL %o", error);
      });
    }
  };
  const disconnectFromWebSocket = () => {
    setWSStatus(WS_CON_STATE_DISCONNECTED);
    if (client && isConnected) {
      onDisconnect(client);
    }
  };

  // Make the context object:
  return {
    connectToWebSocket,
    isConnected,
    disconnectFromWebSocket,
    wsStatus,
    forceReconnect,
    forceDisconnect,
    conditionalWSReconnect,
    ...rest
  };
};